import { Flex, Heading, Spinner, Stack,Text } from "@chakra-ui/react";
import { createColumnHelper } from "@tanstack/react-table";
import { useState, useEffect } from "react";
import {  useNavigate, useParams } from "react-router-dom";
import {   listShippsByStateRequest,   listShippsResponse, Shippment } from "../../../shared";
import { ShippsList } from "../components/shipps-list-card"
import { ENDPOINT_CONFIGS, withParams } from "../endpoints";
import { ApiError, callEndpoint } from "../fetch";
import { isAdmin, isCaptin, isLoggedIn } from "../fetch/auth";
import { ROUTES } from "../routes";
import { CHARGE_STATES, STATES } from "../types";

export const ListShipps = () =>{
  const {state:state}=useParams();

  
  const columnHelper = createColumnHelper<Shippment>();
  
  const columns = [
    columnHelper.accessor("id", {
      cell: (info: { getValue: () => any; }) => <a href={ROUTES.VIEW_SHIPP_With_Id(info.getValue())}><Text fontWeight={'semibold'} color={'blue.500'}>{info.getValue()}</Text></a>,
      header: "الرقم"
    }),
    columnHelper.accessor("description", {
      cell: (info: { getValue: () => any; }) => info.getValue(),
      header: "الوصف"
    }),
    columnHelper.accessor("addrees", {
      cell: (info: { getValue: () => any; }) => info.getValue(),
      header: "العنوان"
    }),
    columnHelper.accessor("charge", {
      cell: (info: { getValue: () => any; }) => info.getValue(),
      header: "القيمة",
      meta: {
        isNumeric: true
      }
    }),
    columnHelper.accessor("chargeState", {
      cell: (info: { getValue: () => any; }) => (((!isAdmin()&&!isCaptin())&&info.getValue()=='3') || isAdmin() || isCaptin())? CHARGE_STATES[info.getValue()]:'_',
      header: "التوريد",
    }),
    columnHelper.accessor("createTime", {
      cell: (info: { getValue: () => any; }) => new Date(info.getValue()).toISOString().split('T')[0],
      header: "تاريخ الإنشاء",
    
    }), 
    columnHelper.accessor("senderId", {
      cell: (info: { getValue: () => any; }) =>  info.getValue(),
      header: "العميل",
    
    }),
...((isAdmin()||(isCaptin()&&state=='2'))? [
    columnHelper.accessor("id", {
      cell: (info: { getValue: () => any; }) => <a href={ROUTES.UPDATE_SHIPP(info.getValue())}><Text color={'red.500'}>Update</Text></a>,
      header: "خيارات"
    })] :[])
  ];


  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [shipps, setShipps]= useState([] as Shippment[]);
  const [busy, setBusy] = useState(true);



  if (!isLoggedIn()) {
      navigate(ROUTES.SIGN_IN);
  }

  useEffect(()=>{
  
    const fetchData = async()=>{
    try{
      const res= await callEndpoint<listShippsByStateRequest, listShippsResponse>
                        (withParams(ENDPOINT_CONFIGS.listShippsOfCrUserByState
                          ,state!));
        setShipps(res.shipps);
        setBusy(false);
      } catch (e) {
        setError((e as ApiError).message);
        setShipps([]);
        setBusy(false);
      }
    }
    if(Number(state)>=0 && Number(state)<=4){
      fetchData();
    }
    else
    {
      setError('هذه الحالة غير موجودة')
    }
    },[])


   if(busy){
    return(
      <div>
         <Flex minH={'100px'} margin={'auto'} align={'center'} justify={'center'} >
        <Spinner></Spinner>
        </Flex>
      </div>
    )
  }
  
if (error){
return(

  <Flex minH={'100px'} margin={'auto'} align={'center'} justify={'center'} >
 {error}
 </Flex>
);}


  return (
   
    <div>
      <Flex padding={4} direction={'column'} dir='rtl'>
      <Stack align={'center'}>
            <Heading fontSize={'2xl'} textAlign={'center'} pb={4}>
             الطرود ({STATES[state!]})
            </Heading>
          </Stack>
      <ShippsList columns={columns} data={shipps}/>
      </Flex>
       {/* <Paginator 
          curPage={curPage}
          setCurPage={setCurPage}
          totalPages={totalPages}
  />*/}
    </div>
  );
}